import { Component, OnInit } from '@angular/core';
import { json } from './featuredObject';

@Component({
  selector: 'app-featuredin',
  templateUrl: './featuredin.component.html',
  styleUrls: ['./featuredin.component.scss']
})
export class FeaturedinComponent implements OnInit {
  featuredInJson = json;
  breakpoints = {
    600: {
      perView: 2,
      showArrows: false
    }
  };

  constructor() { }

  ngOnInit() {
  }

}
